import { useSessionAuth } from '@/context/Auth';
import { CreateChatMessage, sendChatMessage } from '@/infrastructure/api/chat';
import { ChatMessage } from '@/infrastructure/domain/chat';
import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

export type SendChatMessageAttrs = {
  roomId: string;
  payload: CreateChatMessage;
};

export const useSendChatMessage = (
  roomId: string,
): UseMutationResult<
  ChatMessage,
  Error,
  SendChatMessageAttrs,
  unknown
> | null => {
  const queryClient = useQueryClient();
  const { token } = useSessionAuth();

  return useMutation({
    mutationFn: ({ roomId, payload }: SendChatMessageAttrs) =>
      sendChatMessage(token!, roomId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chatRooms', roomId] });
      queryClient.invalidateQueries({ queryKey: ['chatMessages'] });
    },
  });
};
